class Logger {
  static error(...args) {
    // eslint-disable-next-line no-console
    console.error(...args);
  }

  static log(...args) {
    // eslint-disable-next-line no-console
    console.error(...args);
  }
}

export { Logger };
